module.exports = __webpack_public_path__ + "static/media/AVeryBigFallSamples.14a62b2a.jpg";